import React from "react";
import { useRecoilValue } from "recoil";
import { toastState } from "../../recoil/toast";
import styled from "styled-components";

interface CustomToastProps {
  message: string;
  type: string;
}

const CustomToast: React.FC<CustomToastProps> = () => {
  const toast = useRecoilValue(toastState);

  if (!toast.isVisible) {
    return null;
  }

  return (
    <Style>
      <div className="wrap">
        <div className="customToastWrap">
          <div className="customToast">
            {toast.type === "error" ? (
              <img
                src={`${process.env.PUBLIC_URL}/svg/ic_error.svg`}
                alt="search"
              />
            ) : (
              <img
                src={`${process.env.PUBLIC_URL}/svg/ic_success.svg`}
                alt="search"
              />
            )}
            <h1 className="toastMessage">{toast.message}</h1>
          </div>
        </div>
      </div>
    </Style>
  );
};

export default CustomToast;

const Style = styled.div`
  .wrap {
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    z-index: 9999999;
  }
  .customToastWrap {
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .customToast {
    max-width: 60vw;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 18px 40px;
    text-align: left;
    border-radius: 10px;
    background: #ffffff;
  }
  .toastMessage {
    font-size: 32px;
    margin: 0;
    margin-left: 18px;
    font-weight: 500;
    color: #555555;
  }
`;
